// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DtaStageResponse
 */
export interface DtaStageResponse {
    /**
     * 
     * @type {string}
     * @memberof DtaStageResponse
     */
    dta_id: string;
    /**
     * 
     * @type {string}
     * @memberof DtaStageResponse
     */
    workflow_stage: string;
}

/**
 * Check if a given object implements the DtaStageResponse interface.
 */
export function instanceOfDtaStageResponse(value: object): value is DtaStageResponse {
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('workflow_stage' in value) || value['workflow_stage'] === undefined) return false;
    return true;
}

export function DtaStageResponseFromJSON(json: any): DtaStageResponse {
    return DtaStageResponseFromJSONTyped(json, false);
}

export function DtaStageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DtaStageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dta_id': json['dta_id'],
        'workflow_stage': json['workflow_stage'],
    };
}

export function DtaStageResponseToJSON(json: any): DtaStageResponse {
    return DtaStageResponseToJSONTyped(json, false);
}

export function DtaStageResponseToJSONTyped(value?: DtaStageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dta_id': value['dta_id'],
        'workflow_stage': value['workflow_stage'],
    };
}
